(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["valtor-recent"] && !Shopify.designMode) return;
  try {
    function valtorRecentProducts() {
    try {
      const key = 'valtor_recent_products';
      let recent = JSON.parse(sessionStorage.getItem(key) || '[]');
      if (!Array.isArray(recent)) recent = [];
      const current = document.querySelector('[data-valtor-recent-product]');
      if (current) {
        const item = { ...current.dataset };
        recent = [item, ...recent.filter(entry => entry.id !== item.id)].slice(0, 5);
        sessionStorage.setItem(key, JSON.stringify(recent));
      }
      const section = document.querySelector('[data-valtor-recent-list]');
      if (!section) return;
      const basket = section.dataset.cartIds.split(',');
      const container = section.querySelector('.valtor-recent__cards');
      container.replaceChildren();
      for (const item of recent) {
        if (basket.includes(item.id) || !item.url?.startsWith('/products/')) continue;
        const link = document.createElement('a');
        link.href = item.url;
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.title;
        image.width = 120;
        image.height = 160;
        image.loading = 'lazy';
        const title = document.createElement('span');
        title.textContent = item.title;
        link.append(image, title);
        container.append(link);
      }
      section.hidden = !container.children.length;
    } catch (_) {}
  }
  valtorRecentProducts();
  document.addEventListener('shopify:section:load', valtorRecentProducts);
  document.addEventListener('cart:update', event => {
    const section = document.querySelector('[data-valtor-recent-list]');
    const items = event.detail?.resource?.items;
    if (section && Array.isArray(items)) {
      section.dataset.cartIds = items.map(item => item.product_id).join(',');
      valtorRecentProducts();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
